export class BestPostcode{
    items: Array<BestPostcodeItem>;
    hasMore: boolean;
    limit: number;
    offset: number;
    count: number;
    links: Array<BestPostcodeLink>;

    public static mergeJSON(instance: any, data: any): BestPostcode{
        if (!data) { return instance; }
        if (data.items != null) {
            instance.items = [];
            ([].concat(data.items)).forEach(occurrence => {
                instance.items.push(new BestPostcodeItem().fromJSON(occurrence)); // i3
            });
        }

        if (data.hasMore != null) {instance.hasMore = data.hasMore; }
        if (data.offset != null) {instance.offset = data.offset; }
        if (data.limit != null) {instance.limit = data.limit; }
        if (data.count != null) {instance.count = data.count; }
        if (data.links != null) {instance.links = data.links; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestPostcode.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestPostcode) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestPostcode.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestPostcode): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }
}

export class BestPostcodeItem{

    postal_info_namespace: string;
    postal_info_objectid: string;
    postal_info_versionid: string;

    municipality_namespace: string;
    municipality: string;
    municipality_objectid: string;
    municipality_versionid: string;

    part_of_municipality_namespace: string;
    part_of_municipality: string;
    part_of_municipality_objectid: string;
    part_of_municipality_versionid: string;

    public static mergeJSON(instance: BestPostcodeItem, data: any): BestPostcodeItem {
        if (!data) { return instance; }

        if(data.postal_info_namespace != null){instance.postal_info_namespace = data.postal_info_namespace}
        if(data.postal_info_objectid != null){instance.postal_info_objectid = data.postal_info_objectid}
        if(data.postal_info_versionid != null){instance.postal_info_versionid = data.postal_info_versionid}

        if(data.municipality_namespace != null){instance.municipality_namespace = data.municipality_namespace}
        if(data.municipality != null){instance.municipality = data.municipality}
        if(data.municipality_objectid != null){instance.municipality_objectid = data.municipality_objectid}
        if(data.municipality_versionid != null){instance.municipality_versionid = data.municipality_versionid}

        if(data.part_of_municipality_namespace != null){instance.part_of_municipality_namespace = data.part_of_municipality_namespace}
        if(data.part_of_municipality != null){instance.part_of_municipality = data.part_of_municipality}
        if(data.part_of_municipality_objectid != null){instance.part_of_municipality_objectid = data.part_of_municipality_objectid}
        if(data.part_of_municipality_versionid != null){instance.part_of_municipality_versionid = data.part_of_municipality_versionid}

        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return BestPostcodeItem.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: BestPostcodeItem) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return BestPostcodeItem.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: BestPostcodeItem): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

}

export class BestPostcodeLink{
    rel: string;
    href: string;
}